const baseContainer = provided => ({
    display: "inline-block",
    position: "relative",
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #CED4DA",
    borderRadius: "4px",
    ...provided,
})

const baseControl = (
    provided,
    state,
    minHeight = "45px",
    extraStyles = {}
) => ({
    ...provided,
    minHeight,
    borderColor: "#9d9d9d",
    border: 0,
    boxShadow: 0,
    "&:hover": {
        borderColor: "#9d9d9d",
    },
    ...extraStyles,
})

const autoCompleteStyles = {
    // Previous Name DepartmentSelection
    STYLE_ONE: {
        container: provided => ({
            ...provided,
            width: "250px",
            border: "1px solid #CED4DA",
            borderRadius: "4px",
        }),
        control: (provided, state) => ({
            ...provided,
            cursor: "pointer",
            minHeight: "25px",
            borderColor: "#9d9d9d",
            border: 0,
            boxShadow: 0,
            "&:hover": {
                borderColor: "#9d9d9d",
            },
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? "#0B4D89" : "white",
            color: state.isSelected ? "white" : "black",
            cursor: "pointer",
        }),
    },

    //Previous Name AutoCompleteStyling & AddNewRequestSelect
    STYLE_TWO: {
        container: baseContainer,
        control: (provided, state) => baseControl(provided, state, "40px"),
        option: styles => ({ ...styles }),
        menuPortal: base => ({ ...base, zIndex: 9999 }),
    },

    //Previous Name AutoCompleteStylingScrapReturn
    STYLE_THREE: {
        container: provided => ({
            width: "100%",
            ...provided,
        }),
    },

    //Previous Name InventoryHeader
    STYLE_FOUR: {
        container: provided => ({
            ...baseContainer(provided),
            width: "70%",
        }),
        control: (provided, state) => baseControl(provided, state, "45px"),
    },

    //Previous Name ModalVD
    STYLE_FIVE: {
        container: provided => ({
            ...baseContainer(provided),
            width: "130px",
        }),
        control: (provided, state) => baseControl(provided, state, "45px"),
    },

    //Previous Name WarehouseIM
    STYLE_SIX: {
        container: baseContainer,
        control: (provided, state) => baseControl(provided, state, "45px"),
    },

    //Previous Name IMRequests
    STYLE_SEVEN: {
        container: baseContainer,
        control: (provided, state) =>
            baseControl(provided, state, "45px", {
                height: "33px",
            }),
    },
}

export default autoCompleteStyles
